"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IdeaCardTitleSkeleton = exports.IdeaCardMetaSkeleton = void 0;

var _preact = require("preact");

var _Skeleton = require("@insided/shared/uikit/Skeleton");

/**
 * Skeleton components for loading state.
 * Uses universal skeleton components from uikit.
 */
var IdeaCardTitleSkeleton = function IdeaCardTitleSkeleton() {
  return (0, _preact.h)(_Skeleton.TextSkeleton, {
    width: "15em"
  });
};

exports.IdeaCardTitleSkeleton = IdeaCardTitleSkeleton;

var IdeaCardMetaSkeleton = function IdeaCardMetaSkeleton() {
  return (0, _preact.h)("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5em'
    }
  }, (0, _preact.h)(_Skeleton.CircleSkeleton, {
    size: 24
  }), (0, _preact.h)(_Skeleton.TextSkeleton, {
    width: "8em"
  }));
};

exports.IdeaCardMetaSkeleton = IdeaCardMetaSkeleton;